<script setup lang="ts">
import { computed } from 'vue';
import InputText from 'primevue/inputtext';
import InputTextAera from 'primevue/textarea';

interface Props {
  inputValue: object;
  validate: any;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:inputValue': [value: any] }>();

const inputValue = computed({
  get() {
    return props.inputValue;
  },
  set(value) {
    emits('update:inputValue', value);
  }
});
</script>
<template>
  <div class="tour-info-fr">
    <div class="mb-3">
      <label for="tour_name_fr" class="font-title">{{ $t('management.tour.tour_name_fr') }} <span class="text-primary">*</span></label>
      <InputText id="tour_name_fr" :class="validate.tourNameFr?.$error ? 'p-invalid w-full' : 'w-full'" type="text" v-model="inputValue.tourNameFr" />
      <p class="text-red-500 pt-1" v-if="validate.tourNameFr?.$error">{{ $t('validate.required') }}</p>
    </div>
    <div class="mb-3">
      <label for="tour_inclusions_fr" class="font-title"> {{ $t('management.tour.tour_inclusions_fr') }} <span class="text-primary">*</span></label>
      <InputText id="tour_inclusions_fr" :class="validate.tourInclusionFr?.$error ? 'p-invalid w-full' : 'w-full'" type="text" v-model="inputValue.tourInclusionFr" />
      <p class="text-red-500 pt-1" v-if="validate.tourInclusionFr?.$error">{{ $t('validate.required') }}</p>
    </div>
    <div class="mb-3">
      <label for="tour_details_link_fr" class="font-title"> {{ $t('management.tour.tour_details_link_fr') }} <span class="text-primary">*</span></label>
      <InputText id="tour_details_link_fr" :class="validate.tourLinkFr?.$error ? 'p-invalid w-full' : 'w-full'" type="text" v-model="inputValue.tourLinkFr" />
      <p class="text-red-500 pt-1" v-if="validate.tourLinkFr?.$error">{{ $t('validate.required') }}</p>
    </div>
    <div class="mb-3">
      <label for="visited_cities_fr" class="font-title"> {{ $t('management.tour.visited_cities_fr') }} <span class="text-primary">*</span></label>
      <InputText id="visited_cities_fr" :class="validate.visitedCitiesFr?.$error ? 'p-invalid w-full' : 'w-full'" type="text" v-model="inputValue.visitedCitiesFr" />
      <p class="text-red-500 pt-1" v-if="validate.visitedCitiesFr?.$error">{{ $t('validate.required') }}</p>
    </div>
    <div class="mb-3">
      <label for="tour_description_fr" class="font-title">{{ $t('management.tour.tour_description_fr') }}<span class="text-primary">*</span></label>
      <InputTextAera id="tour_description_fr" rows="5" class="w-full tour_description_fr" :class="validate.tourDescriptionFr?.$error ? 'p-invalid w-full' : 'w-full'" v-model="inputValue.tourDescriptionFr"></InputTextAera>
      <p class="text-red-500 pt-1" v-if="validate.tourDescriptionFr?.$error">{{ $t('validate.required') }}</p>
    </div>
  </div>
</template>
